
import { Component, Prop, Vue } from "vue-property-decorator";
import {IAppTable} from "@/shared/AppTable/interfaces/sort-table-data";
import {ICorp} from "@/modules/Corps/interfaces/corp.interface";

@Component({})
export default class ParksCell extends Vue {
  @Prop() cell: IAppTable.ITableProp;
  @Prop() entity: ICorp.IEntity;
  @Prop() index: number;
  @Prop() tableList: ICorp.IEntity[];

  get printedValue() {
    return (this.entity.parks as ICorp.ICorpPark[]).map(park => park.name).join(', ');
  }
}
